// import { useEffect } from 'react';

// import { useRouter } from 'next/router';
import PropTypes from "prop-types";

import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import { challengesLayoutCss } from "./ChallengesLayout.style";

// import useHasContentSettings from '../utils/useHasContentSettings';

const propTypes = {
  children: PropTypes.node,
};

const ChallengesLayout = ({ children }) => {
  const { data: user } = useUser();
  const { isTeacher } = getUserProperties(user);
  // const router = useRouter();
  // const { data: hasContentSettings } = useHasContentSettings();

  // useEffect(() => {
  //   if (hasContentSettings) {
  //     const consetGroups = hasContentSettings.conset_groups;
  //     const hideItems = hasContentSettings.hide_items;
  //     const hideSets = hasContentSettings.hide_sets;
  //     const markerRules = hasContentSettings.marker_rules;
  //     if (consetGroups?.length || hideItems?.length || hideSets?.length || markerRules?.length) {
  //       router.push('/home/');
  //     }
  //   }
  // }, [hasContentSettings]);

  return <div css={challengesLayoutCss(isTeacher)}>{children}</div>;
};

ChallengesLayout.propTypes = propTypes;

export default ChallengesLayout;
